import React from "react";

const TieredParticipantBalanceCard = ({ participantBalance, index }) => {
  return (
    <>
      <div className="ml-3 mr-3 mb-3 partcipantBalanceCard">
        <div className="ml-4 mt-3" style={{ width: "8%" }}>
          <div className="ft-13 fw-600">{index + 1}</div>
        </div>

        {/* <div className="mt-3" style={{ width: "21%" }}>
          <div className="ft-13 fw-600">{"Range from/to"}</div>
        </div> */}

        <div className="mt-3" style={{ width: "31%" }}>
          {participantBalance.to == "" ? (
            <div className="ft-13 fw-600">
              ${participantBalance.from} and above
            </div>
          ) : (
            <div className="ft-13 fw-600">
              ${participantBalance.from} to ${participantBalance.to}
            </div>
          )}
        </div>

        <div className="mt-3">
          <div className="ft-13 fw-600">
            {participantBalance.percentageOrAmountOrBasisPoints}%
          </div>
        </div>
      </div>
    </>
  );
};

export default TieredParticipantBalanceCard;
